<template>
  <div class="container-fluid">
    <div
      class="
        navbar-dark
        project-header
        py-2
        px-1
        d-flex
        justify-content-between
      "
    >
      <!-- <div
        class="gantt-title-wrapper"
        @click="$router.back()"
        style="cursor: pointer"
      >
        <a>
          <img
            class="icon icon-xs"
            src="@/assets/img/icons/svgs/solid/left-arrow.svg"
          />
        </a>

        <span class="align-middle ticket-title__client-name pl-0">Billing</span>
      </div> -->

      <div class="d-flex align-items-center">
        <!-- <button
          class="btn btn-sm text-white bg-green my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          data-toggle="tooltip"
          data-placement="top"
        >
          2232
        </button> -->
      </div>
    </div>

    <!-- <h4>Active Projects</h4> -->
    <div class="card card-body">
      <div v-if="archivedProjects.length > 0 ||  activeProjects.length > 0" class="table-responsive">
        <div>
          <table class="table align-items-center">
            <thead class="thead-light">
              <tr>
                <th scope="col">Project</th>
                <th scope="col">Date</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody class="list">
              <tr v-for="(p, i) in activeProjects" :key="i">
                <th scope="row">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <span class="name mb-0 text-sm">{{ p.name }}</span>
                    </div>
                  </div>
                </th>
                <td class="budget">
                  {{ p.billing_date }}
                </td>
                <td class="budget">
                  {{ p.currency }} {{ p.amount_paid }} - per month
                </td>

                <!-- <td>
                  <div class="avatar-group">
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Ryan Tompson"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-1.jpg"
                      />
                    </a>
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Romina Hadid"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-2.jpg"
                      />
                    </a>
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Alexander Smith"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-3.jpg"
                      />
                    </a>
                    <a
                      href="#"
                      class="avatar avatar-sm rounded-circle"
                      data-toggle="tooltip"
                      data-original-title="Jessica Doe"
                    >
                      <img
                        alt="Image placeholder"
                        src="../../assets/img/theme/team-4.jpg"
                      />
                    </a>
                  </div>
                </td> -->
                <td>
                  <span class="badge badge-dot mr-4">
                    <span class="status">{{
                      p.approval_status.replace("_", " ")
                    }}</span>
                  </span>
                </td>

                <td>
                  <button
                    class="
                      btn btn-sm
                      text-white
                      bg-danger
                      my-2
                      mt-2
                      mb-2
                      ml-2
                      my-md-0
                    "
                    type="button"
                    data-toggle="tooltip"
                    @click="onArchieveClicked(p)"
                    data-placement="top"
                  >
                    Archive
                  </button>
                </td>
              </tr>
              <tr v-for="(p, i) in archivedProjects" :key="i">
                <th scope="row">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <span class="name mb-0 text-sm">{{ p.name }}</span>
                    </div>
                  </div>
                </th>
                <td class="budget">
                  {{ p.billing_date }}
                </td>
                <td class="budget">
                  {{ p.currency }} {{ p.amount_paid }} - per month
                </td>

                <td>
                  <span class="badge badge-dot mr-4">
                    <span class="status">{{
                      p.approval_status.replace("_", " ")
                    }}</span>
                  </span>
                </td>

                <td>
                  <button
                    class="
                      btn btn-sm
                      text-white
                      bg-success
                      my-2
                      mt-2
                      mb-2
                      ml-2
                      my-md-0
                    "
                    type="button"
                    data-toggle="tooltip"
                    @click="onUnArchieveClicked(p)"
                    data-placement="top"
                  >
                    Make Active
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
       <div v-else >
         <div style="text-align:center">
               <span>No archieved or active projects found.</span>
           </div>
          </div>
        </div>
    </div>

    <!-- <h4>Archived Projects</h4>
     <div class="card card-body">
      <div v-if="archivedProjects.length>0"  class="table-responsive">
         <div>
          <table class="table align-items-center">
            <thead class="thead-light">
              <tr>
                <th scope="col" >Project</th>
                <th scope="col" >Date</th>
                <th scope="col" >Amount</th>
                <th scope="col">Status</th>
                <th scope="col" >
                  &nbsp;
                </th>
                
              </tr>
            </thead>
            <tbody class="list">
              <tr v-for="(p, i) in archivedProjects" :key="i">
                <th scope="row">
                  <div class="media align-items-center">
                    
                    <div class="media-body">
                      <span class="name mb-0 text-sm">{{p.name}}</span>
                    </div>
                  </div>
                </th>
                <td class="budget">
                  {{p.billing_date}}
                </td>
                <td class="budget">
                  {{p.currency}} {{p.amount_paid}} - per month
                </td>
                
               
                <td>
                  <span class="badge badge-dot mr-4">
                    <span class="status">{{p.approval_status.replace("_"," ")}}</span>
                  </span>
                </td>

                
                <td>
<button
          class="btn btn-sm text-white bg-success my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          data-toggle="tooltip"
          @click="onUnArchieveClicked(p)"
          data-placement="top"
        >
          Make Active
        </button>
                </td>
                
                
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h4 v-else>No Archived Projects found </h4>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import swal from "sweetalert2";
export default {
  props: ["tasks", "project"],
  components: {},
  name: "Billing",
  data() {
    return {
      activeProjects: [],
      archivedProjects: [],
    };
  },
  computed: {
    ...mapState("user", ["profile"]),
  },
  async mounted() {
    this.refreshRecords();
  },

  methods: {
    ...mapActions("project", [
      "fetchBillingProjects",
      "updateProjectArchieveStatus",
    ]),
    async refreshRecords() {
      try {
        this.activeProjects = await this.fetchBillingProjects("active");
        this.archivedProjects = await this.fetchBillingProjects("archieved");
      } catch (e) {
        console.log(e);
        this.$snack.success("Error fetching billing projects");
      }
    },

    async onArchieveClicked(project) {
      try {
        let res = await this.updateProjectArchieveStatus({
          is_archieved: 1,
          id: project.id,
        });
        await this.refreshRecords();
      } catch (e) {
        console.log(e);
        this.$snack.success("Error archiving the project");
      }
    },

    async onUnArchieveClicked(project) {
      try {
        let res = await this.updateProjectArchieveStatus({
          is_archieved: 0,
          id: project.id,
        });
        await this.refreshRecords();
      } catch (e) {
        console.log(e);
        this.$snack.success("Error archiving the project");
      }
    },
  },
};
</script>

<style lang="css"></style>

<style lang="scss" scoped></style>
